import React from 'react';
import Lottie from 'react-lottie';
import './Pulse_Circle_Lottie.css';
import * as animationData from './Pulse_Circle_Lottie.json';

function Pulse_Circle_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Pulse_Circle_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}         
                />       
        </div>
      </section>
    );
}
export default Pulse_Circle_Lottie;